import L from 'leaflet';
import PassCountIconSVG from '../../../style/assets/map/passCount.svg';

const CreatePassCountIcon = new L.Icon({
    iconUrl: PassCountIconSVG,
    iconSize: [60, 75],
});

export default CreatePassCountIcon;
